export default defineNuxtPlugin(nuxtApp => {
	const {getRoute} = useApiRoutes();
	addRouteMiddleware((to, from) => {
		const path = to.path;

		// New urls do not contain '-katalog' in the end. Check routes for new urls without sufix and redirect
		if (path.startsWith('/katalog/') && path.endsWith('-katalog/')) {
			const newCatalogPath = path.replace('-katalog/', '/');
			if (getRoute(newCatalogPath)) {
				return navigateTo(newCatalogPath, {redirectCode: 301});
			}
			if (!getRoute(path) && ['ErrorLoading', 'Error404'].includes(to.meta.template)) {
				return navigateTo({
					path: '/katalog-neobstaja/',
					query: {
						missing_url: to.params.slug[1],
					},
					redirectCode: 301,
				});
			}
		}

		// If catalog url is not found, redirect to /katalog-neobstaja/
		if(path.startsWith('/katalog/') && ['ErrorLoading', 'Error404'].includes(to.meta.template)) {
			return navigateTo({
				path: '/katalog-neobstaja/',
				redirectCode: 301,
			});
		}

		// If catalog url is not found, check if it exists without '-katalog' sufix
		if (path.startsWith('/katalog-neobstaja/') && to.query.missing_url) {
			const newCatalogPath = '/katalog/' + to.query.missing_url.replace('-katalog', '') + '/';
			if (getRoute(newCatalogPath)) {
				return navigateTo(newCatalogPath, {redirectCode: 301});
			}
		}
	});	
});
